import {BaseComponent} from "./base.component";
import {ActivatedRoute, Data, NavigationExtras, Router} from "@angular/router";
import {lastValueFrom, Observable} from "rxjs";
import {MessageService} from "primeng/api";
import {HttpErrorResponse} from "@angular/common/http";
import {DataResponse, ListDataResponse} from "./models/http.models";
import {Constants} from "./models/shared.models";
import {AppInjector} from "./app.module";
import {ToastrService} from "ngx-toastr";
import {NgxSpinnerService} from "ngx-spinner";
import {AuthService} from "./services/auth.service";

export class BasePageComponent extends BaseComponent {

  private spinner: NgxSpinnerService;
  private toastr: ToastrService;
  private router: Router;
  private messageService: MessageService;
  public authService: AuthService;
  constructor() {
    super();

    this.spinner = AppInjector.get(NgxSpinnerService);
    this.toastr = AppInjector.get(ToastrService);
    this.router = AppInjector.get(Router);
    this.authService = AppInjector.get(AuthService);
    this.messageService = AppInjector.get(MessageService);
  }

  //region Services calls
  protected async asyncCallPromise<T>(block: () => Observable<DataResponse<T>>,
                         onSuccess: (response: DataResponse<T>) => void,
                         onError?: (response: DataResponse<T>) => void,showSpinner? : boolean){
    try {
      if(showSpinner == null || showSpinner == true){
        this.showSpinner();
      }
      const response = await lastValueFrom(block());
      this.hideSpinner();
      if ((response.ErrorCode !== 0 && response.ErrorCode != null) || (response.ErrorMessage != "" && response.ErrorMessage != null)){
        this.showError(response.ErrorMessage ?? Constants.ERROR_DEFAULT_MESSAGE);
        onError?.call(this, response);
        return { success: false, response: response };
      }
      onSuccess(response);
      return { success: true, response: response };
    } catch (e : any) {
      this.hideSpinner();
      if(e.message != "Trovati caratteri non ammessi"){
        this.authService.signOut();
        this.navigate(['/signin']);
      }
      return { success: false };
    }
  }

  protected async asyncCallListPromise<T>(block: () => Observable<ListDataResponse<T>>,
                                      onSuccess: (response: ListDataResponse<T>) => void,
                                      onError?: (response: ListDataResponse<T>) => void,showSpinner? : boolean){
    try {
      if(showSpinner == null || showSpinner == true){
        this.showSpinner();
      }
      const response = await lastValueFrom(block());
      this.hideSpinner();
      if (response.ErrorCode !== 0){
        this.showError(response.ErrorMessage ?? Constants.ERROR_DEFAULT_MESSAGE);
        onError?.call(this, response);
        return { success: false, response: response };
      }
      onSuccess(response);
      return { success: true, response: response };
    } catch (e : any) {
      this.hideSpinner();
      if(e.message != "Trovati caratteri non ammessi"){
        this.authService.signOut();
        this.navigate(['/signin']);
      }
      return { success: false };
    }
  }


  protected asyncCall<T>(block: () => Observable<DataResponse<T>>,
                               onSuccess: (response: DataResponse<T>) => void,
                               showSpinner? : boolean,
                               onError?: (response: DataResponse<T>) => void){
    this.asyncCallPromise(block, onSuccess, onError,showSpinner).then();
  }
  protected asyncListCall<T>(block: () => Observable<ListDataResponse<T>>,
                         onSuccess: (response: ListDataResponse<T>) => void, showSpinner? : boolean,
                         onError?: (response: ListDataResponse<T>) => void){
    this.asyncCallListPromise(block, onSuccess, onError,showSpinner).then();
  }
  //endregion Services calls

  protected showSpinner(){
    this.spinner.show().catch();
  }

  protected hideSpinner(){
    this.spinner.hide().catch();
  }

  //region Navigation
  protected getCurrentPageUrl(){
    return this.router.url;
  }
  protected navigate(commands: any[], extras?: NavigationExtras){
    this.router.navigate(commands, extras).catch(() => {
      this.messageService.add({severity:'error', summary:"Navigazione non valida", detail:"Impossibile aprire la pagina richiesta"});
    });
  }
  //endregion Navigation


  //region Messages
  protected showMessageSaveCompleted(){
    this.showSuccess("Dati salvati correttamente!");
  }
  protected showMessageDeletionCompleted(){
    this.showSuccess("Dati eliminati");
  }

  protected showError(message: string, title?: string){
    this.messageService.add({severity:'error', summary:title, detail:message});
  }
  protected showSuccess(message: string, title?: string){
    this.messageService.add({severity:'success', summary:title, detail:message});
  }
  protected showInfo(message: string, title?: string){
    this.toastr.info(message, title);
    // this.showMessage(message, title, 'info');
  }

  protected showWarning(message: string, title?: string){
    this.messageService.add({severity:'warn', summary:title, detail:message});
  }

  protected showMessage(message: string, title?: string, severity?: string){
    this.messageService.add({
      severity: severity ?? 'info',
      summary: title,
      detail: message
    });
  }

  //endregion Messages
}


